export const actionSubType = {
  0: '表单预约',
  1: '在线咨询', // 在线咨询
  2: '普通电话',
  4: '智能电话', // 智能电话
  5: '发券', // 优惠券
  6: '智能咨询', // 智能咨询
  7: '抽奖', // action_type=CLAIM_OFFER, operator_id=10048, object=lottery,
  10: '一键授权',
  11: '加企业微信客服',
  12: '公众号内注册',
};

export const actionSubTypeForTableFilter = {
  0: '表单预约',
  2: '普通电话',
  4: '智能电话', // 智能电话
  5: '发券', // 优惠券
  6: '智能咨询', // 智能咨询
  7: '抽奖', // action_type=CLAIM_OFFER, operator_id=10048, object=lottery,
  10: '一键授权',
  11: '加企业微信客服',
  12: '公众号内注册',
};
